var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInHomeMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 88,
    viewBox: "0 0 92 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 79.3337V37.667H0.164062L45.9974 0.166992L91.8307 37.667H79.3307V41.8337H70.9974V31.3128L45.9974 10.8962L20.9974 31.3128V71.0003H29.3307V79.3337H12.6641ZM55.1641 87.667L37.6641 70.167L43.4974 64.3337L55.1641 76.0003L79.7474 51.417L85.5807 57.2503L55.1641 87.667Z",
    fill: "#6761EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInHomeMode);
export default __webpack_public_path__ + "static/media/icon_in_home_mode.3bc0eb39b421455c1854f5f31c0f7ca2.svg";
export { ForwardRef as ReactComponent };